module.exports = __webpack_public_path__ + "img/kobikom-logo.1e6ee0e0.svg";